var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("Login")]),_c('p',[_vm._v("Use your credentials to login")]),_c('sign-in1-form',{model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }